<ng2-slim-loading-bar color="#D04A02"></ng2-slim-loading-bar>
<app-notification-container></app-notification-container>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>